import React, { useState, useEffect } from 'react';
import { getRandomHeroImage } from '../data/heroImages';
import styles from './CenterContent.module.css';

const CenterContent: React.FC = () => {
  const [heroImageSrc, setHeroImageSrc] = useState<string>('');

  useEffect(() => {
    // Seleziona un'immagine casuale quando il componente viene montato
    const randomImage = getRandomHeroImage();
    setHeroImageSrc(randomImage);
  }, []);

  return (
    <div className={styles.centerContent}>
      <div className={styles.projectContainer}>
        <img
          src={heroImageSrc}
          alt="Immagine Progetto Random"
          className={styles.heroImage}
        />
      </div>
    </div>
  );
};

export default CenterContent;
